import React from 'react';

const RosterManagement: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-h1 font-lato-bold text-custom-text mb-6">
        Roster Management
      </h1>
      <div className="text-center py-16">
        <h2 className="text-h3 font-lato-bold text-custom-text-secondary">
          Roster management feature coming soon!
        </h2>
      </div>
    </div>
  );
};

export default RosterManagement;

